import { clsx } from 'clsx';
import { NavLink } from 'react-router';

interface MobileNavLinkProps {
  label: string;
  route: string;
}

export default function MobileNavLink({ label, route }: MobileNavLinkProps) {
  return (
    <NavLink to={route} className="no-underline">
      {({ isActive }) => (
        <div
          className={clsx('rounded px-2 py-4 hover:opacity-80', {
            'text-primary-foreground': !isActive,
            'text-secondary': isActive,
          })}
        >
          <div className="font-mono uppercase">{label}</div>
        </div>
      )}
    </NavLink>
  );
}
